import { render, staticRenderFns } from "./idCard.vue?vue&type=template&id=2ee0c9e6&scoped=true&"
import script from "./idCard.vue?vue&type=script&lang=js&"
export * from "./idCard.vue?vue&type=script&lang=js&"
import style0 from "./idCard.vue?vue&type=style&index=0&id=2ee0c9e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee0c9e6",
  null
  
)

export default component.exports